import { api } from "api";
import { useMutation, useQuery } from "@tanstack/react-query";

import { T_Api_Paginated } from "./api.types";
import { T_Testimonials } from "dtos/testimonial.dto";

export const testimonialService = {
  useGetAllPaginated: ({
    page,
    limit,
    rating,
    term = "",
  }: {
    page: number;
    limit: number;
    rating: number | undefined;
    term: string;
  }) => {
    return useQuery({
      queryKey: ["testimonial/all", page, limit, rating],
      queryFn: async () => {
        const res = await api.get(`/testimonial?page=${page}&limit=${limit}&rating=${rating}&queryString=${term}`);
        return res.data?.result as T_Api_Paginated<T_Testimonials>;
      },
    });
  },
  useGetByIdOrSlug: (id: string | undefined) => {
    return useQuery({
      queryKey: ["testimonial", id],
      queryFn: async () => {
        const res = await api.get(`/testimonial/${id}`);
        return res.data?.result as T_Testimonials;
      },
      enabled: !!id,
    });
  },
  useUpdatetestimonial: () => {
    return useMutation({
      mutationKey: ["testimonial/update"],
      mutationFn: async ({ id, body }: { id: string; body: T_Testimonials }) => {
        return api.patch(`/testimonial/${id}`, body);
      },
    });
  },
  useAddTestimonial: () => {
    return useMutation({
      mutationKey: ["testimonial/add"],
      mutationFn: async (body: T_Testimonials) => {
        const res = await api.post("/testimonial/create", body);
        return res.data?.result as T_Testimonials;
      },
    });
  },
};
